import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import FloorMapButton from './floor-map-button';
import { adjustMapboxControlPosition, initializeRichMap } from './util';
import { invokeRichMapMethod, isSelectedFloorSourceReady, waitForSelectedFloorSource, } from './rich-map';
import { POI_TYPES, POI_TYPES_ORIGINAL, sendTrackingEventForMapClick, } from '../../util';
import { useTranslation } from 'react-i18next';
import { useMap } from '../../layout/MapContext';
import DeskHelper from './desk/desk';
import { closeRoomDetailsPopup } from '../room-details-popup';
import { store } from '../../../../../store/store';
import { setRoomDataFromMap, setPOIDataFromMap, setDeskDataFromMap, setRichMapLoading, setDirections, setDirectionsPanel, getCheckIfModelReqFlag, setRoomDetailsPopUp, setShowQRFrame, getShowOnMap, setShowOnMap, clearPOISelection, } from '../../../../../store/uislice';
import { WhereAmISwitchFloor } from '../where-am-i-switch-floor';
import MultifloorDirectionsBar from '../multifloor-directions-bar';
import { useDispatch, useSelector } from 'react-redux';
import { getLocation, getContext, setSelectedLocation, getSelectedLocation, } from '../../../redux/spaces-slice';
import styled from 'styled-components';
import { getDestinationRichMapId, getDestinationFloorNumber, getDirections, setRoomSearchPopUp, } from '../../../../../store/uislice';
import { createShowOccupancyPredicateForFloor, resolveDeskBookable, } from '../../util/show-path-finding';
import { createHiddenOnKioskPredicateForFloor } from '../../util/show-on-kiosk';
import { resolveWhereAmIFloor } from '../../util/where-am-i';
import { getLocalizedNavigationConnectorName } from '../../util/navigation-connector';
import { getRichMapTenantOptions, getTenantFeatureConfig, } from '../../../../../common/util/tenant-feature-config';
const ActionBar = styled.div `
  display: flex;
  align-items: center;
  gap: clamp(0.45rem, 0.55vw, 0.65rem);
  padding: clamp(0.45rem, 0.55vw, 0.58rem);
  border-radius: clamp(0.8rem, 0.92vw, 0.95rem);
  background: linear-gradient(
    180deg,
    rgba(34, 42, 52, 0.82) 0%,
    rgba(28, 35, 44, 0.82) 100%
  );
  box-shadow:
    inset 0 1px 0 rgba(120, 138, 160, 0.14),
    0 20px 44px rgba(0, 0, 0, 0.28);

  @media (max-width: 768px) {
    gap: 0.35rem;
    padding: 0.4rem;
    border-radius: 0.75rem;
  }
`;
const Button = styled.button `
  appearance: none;
  border: ${({ $variant }) => $variant === 'ghost'
    ? '1px solid rgba(121, 138, 160, 0.52)'
    : '1px solid transparent'};
  background: ${({ $variant }) => {
    if ($variant === 'primary') {
        return 'linear-gradient(180deg, rgba(50, 132, 235, 0.82) 0%, rgba(36, 112, 215, 0.82) 100%)';
    }
    if ($variant === 'secondary') {
        return 'linear-gradient(180deg, rgba(86, 98, 115, 0.82) 0%, rgba(75, 87, 104, 0.82) 100%)';
    }
    return 'rgba(39, 47, 58, 0.8)';
}};
  box-shadow: ${({ $variant }) => $variant === 'ghost'
    ? 'none'
    : 'inset 0 1px 0 rgba(191, 208, 230, 0.12), 0 6px 16px rgba(0, 0, 0, 0.24)'};
  border-radius: clamp(0.72rem, 0.82vw, 0.86rem);
  min-height: clamp(2.6rem, 2.8vw, 2.85rem);
  padding: 0 clamp(0.82rem, 0.95vw, 1rem);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.42rem, 0.52vw, 0.58rem);
  color: #f5f7fb;
  font-family: 'Sora', sans-serif;
  font-size: clamp(0.86rem, 1vw, 1.05rem);
  font-weight: 400;
  letter-spacing: -0.02em;
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  @media (max-width: 768px) {
    min-height: 2.2rem;
    padding: 0 0.7rem;
    font-size: 0.8rem;
    border-radius: 0.72rem;
  }
`;
const SearchButton = styled(Button) `
  min-width: clamp(8.6rem, 9.5vw, 10rem);
`;
const WhereAmIButton = styled(Button) `
  min-width: clamp(10.6rem, 11.8vw, 12.2rem);
  justify-content: flex-start;
  padding-right: clamp(1rem, 1.1vw, 1.15rem);

  @media (max-width: 768px) {
    min-width: 7.2rem;
    justify-content: center;
    padding-right: 0.7rem;
  }
`;
const ResetButton = styled(Button) `
  min-width: clamp(11.4rem, 12.8vw, 13.6rem);
`;
const Line = styled.div `
  width: 1px;
  height: clamp(2.5rem, 2.8vw, 2.85rem);
  background: rgba(112, 126, 145, 0.24);

  @media (max-width: 768px) {
    height: 2.5rem;
  }
`;
const ButtonIcon = styled.img `
  width: ${({ $size }) => $size || '1.2rem'};
  height: ${({ $size }) => $size || '1.2rem'};
  display: block;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    width: calc(${({ $size }) => $size || '1.45rem'} * 0.82);
    height: calc(${({ $size }) => $size || '1.45rem'} * 0.82);
  }
`;
const WhereAmIText = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
`;
const WhereAmIIconSpacer = styled.span `
  width: clamp(2.9rem, 3.3vw, 3.4rem);
  flex: 0 0 auto;

  @media (max-width: 768px) {
    display: none;
  }
`;
const WhereAmIMascot = styled.img `
  position: absolute;
  left: clamp(0.58rem, 0.7vw, 0.78rem);
  bottom: -0.08rem;
  width: clamp(2.55rem, 2.95vw, 3.1rem);
  height: auto;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;
const THEMES = {
    DARK_WITHOUT_WORLD_MAP: 'dark-wo-world-map.json',
    DARK: 'dark.json',
};
const RICH_MAP_BACKGROUND_COLOR = '#101214';
const changeRichMapBackgroundColor = (hexaColor) => {
    var _a;
    const richMap = window.rMap;
    if ((_a = richMap === null || richMap === void 0 ? void 0 : richMap.map) === null || _a === void 0 ? void 0 : _a.getLayer('rms-background')) {
        richMap.map.setPaintProperty('rms-background', 'background-color', hexaColor);
        console.log('Rich Maps background color changed');
    }
    else {
        console.error('Cannot reset background: map or layer not available');
    }
};
const MapComponent = ({ richMapAccessToken, mapDetails, roomAvailability, deskStatus, 
// theme = 'DARK_WITHOUT_WORLD_MAP',
showRoomDetailsPopup, showPOI = true, isSimulated = false, isSearchOpen = false, }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { mapjs } = useMap();
    // const { id: floorLocationId } = location.state || floorId;
    let floorLocationId = useSelector(getSelectedLocation);
    const locationData = useSelector(getLocation);
    const showOnMap = useSelector(getShowOnMap);
    if (!floorLocationId) {
        // If no id present, we are in building view. Just take the first id in children to get the map loaded
        floorLocationId = ((_a = locationData === null || locationData === void 0 ? void 0 : locationData.children[0]) === null || _a === void 0 ? void 0 : _a.id) || '';
    }
    const floorLocationData = locationData === null || locationData === void 0 ? void 0 : locationData.children.find((child) => child.id === floorLocationId);
    const currentFloorNumber = Number(floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.floorNumber);
    const destinationRichMapId = useSelector(getDestinationRichMapId);
    // Prefer the authoritative destination floor captured at directions-start;
    // fall back to parsing the rich map id for any legacy callers.
    const storedDestinationFloorNumber = useSelector(getDestinationFloorNumber);
    const destinationFloorNumber = storedDestinationFloorNumber !== null && storedDestinationFloorNumber !== void 0 ? storedDestinationFloorNumber : Number(destinationRichMapId === null || destinationRichMapId === void 0 ? void 0 : destinationRichMapId.split('~')[0]);
    const contextInfo = useSelector(getContext);
    const whereAmIFloor = resolveWhereAmIFloor(locationData, contextInfo);
    const hasWhereAmISource = Boolean(whereAmIFloor);
    const deviceLocationId = whereAmIFloor === null || whereAmIFloor === void 0 ? void 0 : whereAmIFloor.id;
    const deviceFloorNumber = Number(whereAmIFloor === null || whereAmIFloor === void 0 ? void 0 : whereAmIFloor.floorNumber);
    const isInteractive = (_b = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.interactive) !== null && _b !== void 0 ? _b : true;
    const isBuildingViewType = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) === 'building';
    const theme = ((_d = (_c = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _c === void 0 ? void 0 : _c.floor) === null || _d === void 0 ? void 0 : _d.theme) || 'DARK_WITHOUT_WORLD_MAP';
    let shouldShowWhereAmI = Boolean(whereAmIFloor);
    if (!isBuildingViewType && deviceLocationId !== floorLocationId) {
        shouldShowWhereAmI = false;
    }
    const [mapInit, setMapInit] = useState(null);
    const [antiAliasTenants, setAntiAliasTenants] = useState(null);
    const [showSearchButton, setShowSearchButton] = useState(true);
    const showFindMeButton = shouldShowWhereAmI;
    const [showResetButton, setShowResetButton] = useState(true);
    // const [deskStatus] = useState<any>(null); //setDeskStatus
    const deskHelperObj = useRef(new DeskHelper()).current;
    const [showWhereAmISwitchFloor, setShowWhereAmISwitchFloor] = useState(false);
    const [activeRichMapFloorNumber, setActiveRichMapFloorNumber] = useState(null);
    const appliedFloorNumberRef = useRef(null);
    const floorReadyCleanupRef = useRef(null);
    const pendingLocateFloorRef = useRef(null);
    // richMapId -> availability key for highlights we've confirmed applied on a
    // feature that actually exists in the source. Lets us apply each feature exactly
    // once instead of re-clearing + re-setting all 500+ every pass (which is what
    // froze the map, since changeFeatureState is expensive in this SDK).
    const appliedHighlightsRef = useRef(new Map());
    // Per-floor "highlight resolver" cache. The SDK's changeFeatureState() runs a
    // full-source querySourceFeatures scan on EVERY call (and a second scan + a
    // point-in-polygon test per desk for workstations), making a Rooms<->Desks
    // toggle O(N^2) and freezing the map at 200-400 desks. Those lookups are static
    // per floor, so we precompute them once (sType by id + each workstation's
    // 'Workstation Desk' child id) and then apply highlights with direct O(1)
    // map.setFeatureState calls. Keyed by floor number; invalidated on floor change.
    const highlightResolverRef = useRef(null);
    // Cancels the in-flight (chunked, retrying) highlight cycle.
    const highlightCancelRef = useRef(null);
    // Tracks the last toggle (Rooms/Desks/All) so we can tell a toggle change (which
    // should restart highlighting immediately) from a plain availability update
    // (which must NOT restart, so the running cycle keeps its retry tail alive).
    const prevShowOnMapRef = useRef(showOnMap);
    // Bumped once the map/source is actually ready (mapbox 'idle' after ON_LOAD).
    // The cold-load highlight pass can run before the selected-floor source can
    // accept feature-states; that pass ends and, because roomAvailability is
    // memoized, nothing re-runs highlighting until a showOnMap toggle. This tick
    // forces exactly one cancel+restart from the CURRENT render (correct showOnMap),
    // closing that gap. See the effect that consumes it below.
    const [highlightRearmTick, setHighlightRearmTick] = useState(0);
    // Ensures the cold-load "source ready" re-application (clear bookkeeping +
    // re-sync) runs at most once, so later idle ticks can't repaint highlights.
    const coldRehighlightDoneRef = useRef(false);
    // Bounds the "source not ready yet" retries so a floor source that never loads
    // can't spin the re-arm tick forever.
    const coldRehighlightAttemptsRef = useRef(0);
    const showMultifloorDirectionsBar = Boolean(destinationRichMapId) &&
        Boolean(whereAmIFloor) &&
        destinationFloorNumber !== deviceFloorNumber;
    // Keep the action buttons up while a cross-floor route is loading; only swap to
    // the directions stepper once we actually have the SDK route/transition data
    // (connector resolved) or after a 5s timeout. The bar itself stays mounted the
    // whole time (its effects drive navigation), but renders null until ready.
    const directionsData = useSelector(getDirections);
    const isConnectorResolved = getLocalizedNavigationConnectorName(directionsData, t) !== null;
    const [directionsPanelTimedOut, setDirectionsPanelTimedOut] = useState(false);
    useEffect(() => {
        setDirectionsPanelTimedOut(false);
        if (!showMultifloorDirectionsBar || isConnectorResolved) {
            return;
        }
        const timeoutId = window.setTimeout(() => {
            setDirectionsPanelTimedOut(true);
        }, 5000);
        return () => window.clearTimeout(timeoutId);
    }, [showMultifloorDirectionsBar, destinationRichMapId, isConnectorResolved]);
    const isDirectionsPanelReady = showMultifloorDirectionsBar &&
        (isConnectorResolved || directionsPanelTimedOut);
    const destinationRichMapIdRef = useRef(destinationRichMapId);
    useEffect(() => {
        destinationRichMapIdRef.current = destinationRichMapId;
    }, [destinationRichMapId]);
    const clearActiveDirections = () => {
        var _a, _b;
        store.dispatch(setDirectionsPanel({ payload: null }));
        store.dispatch(setDirections({ payload: null }));
        store.dispatch(setRoomDetailsPopUp({ payload: null }));
        store.dispatch(setShowQRFrame({ payload: true }));
        (_a = window.rMap) === null || _a === void 0 ? void 0 : _a.exitNavigation();
        (_b = window.rMap) === null || _b === void 0 ? void 0 : _b.reset();
    };
    // De-highlight any active POI selection (e.g. a "cafeteria" search highlight).
    // We clear the SDK selection for every POI type directly so the highlight is
    // removed immediately AND the SDK has no lingering selection to re-apply on the
    // next floor (the POIs panel's clear effect only runs on a clearPOIs toggle /
    // remount, not on floor change, which is why the highlight used to persist).
    // The dispatch keeps the panel's selected-tile UI in sync.
    const clearPoiHighlights = () => {
        for (const type of POI_TYPES_ORIGINAL) {
            invokeRichMapMethod('updatePoiSelection', type, true);
        }
        store.dispatch(clearPOISelection());
    };
    const locateWhenFloorIsReady = (floorNumber) => {
        if (pendingLocateFloorRef.current !== floorNumber)
            return;
        pendingLocateFloorRef.current = null;
        invokeRichMapMethod('locate');
    };
    // Tie all work that depends on a completed floor transition to the actual
    // selected-floor source lifecycle. This replaces fixed delays that were too
    // short on Webex boards and unnecessarily long on faster browsers.
    const completeFloorChangeWhenReady = (floorNumber, onReady) => {
        if (floorReadyCleanupRef.current) {
            floorReadyCleanupRef.current();
            floorReadyCleanupRef.current = null;
        }
        setActiveRichMapFloorNumber(null);
        let cleanup = () => undefined;
        cleanup = waitForSelectedFloorSource(() => {
            if (floorReadyCleanupRef.current !== cleanup)
                return;
            floorReadyCleanupRef.current = null;
            if (appliedFloorNumberRef.current !== floorNumber)
                return;
            checkIfModelRequired();
            onReady === null || onReady === void 0 ? void 0 : onReady();
            setActiveRichMapFloorNumber(floorNumber);
            syncSpaceHighlights();
            locateWhenFloorIsReady(floorNumber);
        });
        floorReadyCleanupRef.current = cleanup;
    };
    // Layer 1 — floor-restoring teardown.
    // The SDK's reset()/exitNavigation() do NOT restore the rendered floor, so
    // ending a cross-floor route can leave the map on the destination floor while
    // the app's desired floor (mapDetails.map.floorNumber) is unchanged — the UI
    // then shows one floor while the map renders another. This forces the SDK back
    // to the desired floor, mirroring the floor-change branch of
    // checkIfFloorChangeRequired (clear highlights + cancel the in-flight cycle +
    // changeFloor + post-settle re-sync) so highlights can't orphan. It's invoked
    // only from teardown paths where a cross-floor route was actually active, so it
    // adds no cost to normal interactions.
    const restoreDesiredFloorAfterTeardown = () => {
        if (!window.rMap)
            return;
        const desiredFloor = mapDetails.map.floorNumber;
        if (Number.isNaN(Number(desiredFloor)))
            return;
        clearPoiHighlights();
        clearAllAppliedHighlights();
        if (highlightCancelRef.current) {
            highlightCancelRef.current();
            highlightCancelRef.current = null;
        }
        appliedFloorNumberRef.current = desiredFloor;
        completeFloorChangeWhenReady(desiredFloor);
        invokeRichMapMethod('changeFloor', desiredFloor, true);
    };
    useEffect(() => {
        let cancelled = false;
        void getTenantFeatureConfig().then((config) => {
            if (!cancelled)
                setAntiAliasTenants(config.antiAliasTenants);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    useEffect(() => {
        if (mapjs && antiAliasTenants) {
            console.log('Loaded Rich Map JS script; mapInit', mapInit, ' mapDetails:', mapDetails);
            // preferDefaultSettings tells the SDK to use its default camera instead of
            // the saved pitch/bearing/zoom. Resolve it to true only when the backend
            // explicitly asks for the default view, OR when none of pitch/bearing/zoom
            // are set (all null/undefined). Otherwise honor the saved camera.
            const preferDefaultSettings = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.showDefaultView) === true ||
                ((contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.pitch) == null &&
                    (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.bearing) == null &&
                    (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.zoom) == null);
            const newMapInit = Object.assign(Object.assign(Object.assign({ mapContainer: 'map-v2', token: richMapAccessToken === null || richMapAccessToken === void 0 ? void 0 : richMapAccessToken.accessToken, tenantId: mapDetails.map.tenantId, locationId: mapDetails.map.buildingId, initialZoom: mapDetails.map.zoom, initialPos: [mapDetails.map.long, mapDetails.map.lat], initialPitch: mapDetails.map.pitch, initialBearing: mapDetails.map.bearing, defaultFloor: mapDetails.map.floorNumber, hideNavigationControls: true, disableMapboxAttribution: true, 
                // theme: (window as any).rMap.Themes[theme],
                theme: THEMES[theme], useTiles: false }, richMapAccessToken), { preferDefaultSettings }), getRichMapTenantOptions(mapDetails.map.tenantId, antiAliasTenants));
            setMapInit(newMapInit);
            initializeRichMap(newMapInit);
            appliedFloorNumberRef.current = mapDetails.map.floorNumber;
            setActiveRichMapFloorNumber(null);
            adjustMapboxControlPosition();
            showButtons();
            window.rMap.listen(RichMapEvent.ON_LOAD, () => {
                var _a, _b, _c, _d, _e;
                console.log('Rich Maps ON_LOAD Event...');
                changeRichMapBackgroundColor(RICH_MAP_BACKGROUND_COLOR);
                setTimeout(() => {
                    store.dispatch(setRichMapLoading({ payload: true }));
                }, 1000);
                const val = window.rMap.doRoomHighlight;
                console.log('doRoomHighlight :: ', val);
                //checkIfFloorChangeRequired();
                // checkIfModelRequired();
                window.rMap.loaded = true;
                completeFloorChangeWhenReady(mapDetails.map.floorNumber);
                syncSpaceHighlights();
                // Re-arm highlighting once the floor source is truly ready. The call above
                // can run before 'selected-floor' can accept feature-states (its
                // changeFeatureState calls get dropped), and nothing else re-triggers it on
                // a cold load until a showOnMap toggle. Mapbox 'idle' fires once the map has
                // finished loading/rendering its sources, so bump the tick then; a timeout
                // fallback covers the rare case where idle has already passed. The tick is
                // handled from the current render (correct selection), so this can't apply a
                // stale showOnMap.
                try {
                    const glMap = (_a = window.rMap) === null || _a === void 0 ? void 0 : _a.map;
                    if (glMap && typeof glMap.once === 'function') {
                        glMap.once('idle', () => setHighlightRearmTick((tick) => tick + 1));
                    }
                }
                catch (e) {
                    /* ignore: fallback below still re-arms */
                }
                setTimeout(() => setHighlightRearmTick((tick) => tick + 1), 1500);
                const features = window.rMap.getFeatures();
                const POIs = {};
                const allRooms = [];
                const allDesks = [];
                const POISNameMap = {};
                for (const type of POI_TYPES) {
                    POIs[type] = [];
                }
                for (const feature of features) {
                    // fid is undefined for most features, hence going to obtain it from the poid itself by splitting
                    POISNameMap[feature.id.includes('~')
                        ? feature.id.slice(feature.id.indexOf('~') + 1)
                        : feature.id] = {
                        name: (_b = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _b === void 0 ? void 0 : _b.name,
                        sType: (_c = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _c === void 0 ? void 0 : _c.sType,
                        poiId: (_d = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _d === void 0 ? void 0 : _d.fid,
                    };
                    if (feature.properties.type === 'meeting-space' ||
                        feature.properties.type === 'work-space') {
                        const featureObj = {
                            name: feature.id.split('~')[1],
                            floorNumber: Number(feature.properties.lvl),
                            availability: 'Unknown',
                            key: feature.id,
                            // Unique per-feature id. `key` (richMapId = <lvl>~<name>) collides
                            // when several spaces on a floor share a name, so we carry `fid`
                            // to focus the exact feature (falls back to `key` if absent).
                            fid: (_e = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _e === void 0 ? void 0 : _e.fid,
                            capacity: 'Unknown',
                        };
                        if (feature.properties.type === 'meeting-space')
                            allRooms.push(featureObj);
                        if (feature.properties.type === 'work-space')
                            allDesks.push(featureObj);
                    }
                    if (feature.isPOI) {
                        if (feature.properties.type === 'toilets') {
                            POIs['Rest Rooms'].push(feature);
                        }
                        else if (feature.properties.type === 'restaurant') {
                            POIs['Cafeteria'].push(feature);
                        }
                        else if (feature.properties.type === 'help-desk') {
                            POIs['Help Desk'].push(feature);
                        }
                        else if (feature.properties.type === 'child-care') {
                            POIs['Child Care Area'].push(feature);
                        }
                        else if (feature.properties.type === 'stairs') {
                            POIs['Stairs'].push(feature);
                        }
                        else if (feature.properties.type === 'lift') {
                            POIs['Elevators'].push(feature);
                        }
                    }
                }
                store.dispatch(setDeskDataFromMap({ payload: allDesks }));
                store.dispatch(setRoomDataFromMap({ payload: allRooms }));
                store.dispatch(setPOIDataFromMap({
                    payload: { POIs, POISNameMap },
                }));
                // Positioning and other floor-dependent work runs when the underlying
                // selected-floor source reports ready.
            });
            window.rMap.listen(RichMapEvent.ON_CLICK, function (e) {
                var _a;
                console.log('Rich Maps ON_CLICK Event...', e);
                if (!isInteractive) {
                    return;
                }
                store.dispatch(setShowQRFrame({ payload: true }));
                const spaceFeatures = window.rMap.getFeaturesAtPoint(e, [
                    POITypes.MEETING_SPACES,
                    POITypes.WORK_SPACES,
                ]);
                const fallbackFeatures = window.rMap
                    .getFeaturesAtPoint(e)
                    .filter((el) => { var _a, _b; return ((_a = el === null || el === void 0 ? void 0 : el.feature) === null || _a === void 0 ? void 0 : _a.isPOI) && ((_b = el === null || el === void 0 ? void 0 : el.feature) === null || _b === void 0 ? void 0 : _b.id); });
                const featuresNew = spaceFeatures.length > 0 ? spaceFeatures : fallbackFeatures;
                const clickedFeature = (_a = featuresNew[0]) === null || _a === void 0 ? void 0 : _a.feature;
                const clickedFeatureId = (clickedFeature === null || clickedFeature === void 0 ? void 0 : clickedFeature.id) || null;
                if (destinationRichMapIdRef.current) {
                    clearActiveDirections();
                }
                if (!clickedFeatureId) {
                    return;
                }
                // Selecting a room/feature de-highlights any lingering POI search
                // highlight (e.g. "cafeteria") so it doesn't stay blue on the map.
                clearPoiHighlights();
                const clickedRoom = mapStatus.roomAvailability[clickedFeatureId];
                setTimeout(() => {
                    var _a;
                    sendTrackingEventForMapClick(clickedFeatureId, contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.tenantId);
                    // Kick off the camera animation first, then let the browser paint a
                    // couple of frames before committing the (heavy) popup render. Doing
                    // both in the same tick starves the map's requestAnimationFrame loop
                    // and makes the zoom visibly stutter.
                    // Focus the exact feature that was clicked. `clickedFeatureId`
                    // (richMapId) can be shared by several same-named spaces on a floor,
                    // which would zoom to the wrong one; the clicked feature's unique
                    // `fid` disambiguates. Falls back to the id if `fid` is absent.
                    focusRichMapLocation(((_a = clickedFeature === null || clickedFeature === void 0 ? void 0 : clickedFeature.properties) === null || _a === void 0 ? void 0 : _a.fid) || clickedFeatureId);
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            showRoomDetailsPopup(clickedFeatureId, clickedRoom === null || clickedRoom === void 0 ? void 0 : clickedRoom.location, clickedRoom === null || clickedRoom === void 0 ? void 0 : clickedRoom.floorNumber);
                        });
                    });
                }, destinationRichMapIdRef.current ? 120 : 0);
                // (window as any).rMap?.current?.map?.on('zoomend', () => {
                //   sendTrackingEventForZoomChange(
                //     (window as any).rMap?.current?.map?.getZoom()?.toFixed(1),
                //     contextInfo?.tenantId
                //   );
                // });
            });
            window.rMap.listen(RichMapEvent.NAVIGATION_DATA_LOAD, function (navData) {
                var _a;
                store.dispatch(setDirections({ payload: navData.directions }));
                console.log(`Received : RichMapEvent.NAVIGATION_DATA_LOAD with directions : ${JSON.stringify(navData.directions, null, 2)}`);
                // Dump the FULL navigation callback object (not just `directions`) so
                // the complete SDK payload — every feature property (transitionInfo /
                // portalName / type / levels / etc.) — can be inspected to see where
                // the stairs-vs-elevator transition data actually lives. Temporarily
                // unconditional (not localhost-gated) so it's visible on QA too.
                try {
                    console.log('[NAVIGATION_DATA_LOAD] full navData:', JSON.stringify(navData, null, 2));
                    // Concise per-feature transition summary for quick scanning.
                    const features = (_a = navData === null || navData === void 0 ? void 0 : navData.directions) === null || _a === void 0 ? void 0 : _a.features;
                    if (Array.isArray(features)) {
                        console.log('[NAVIGATION_DATA_LOAD] transition summary:', features.map((feature, index) => {
                            var _a, _b, _c;
                            return ({
                                index,
                                type: (_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.type,
                                portalName: (_b = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _b === void 0 ? void 0 : _b.portalName,
                                transitionInfo: (_c = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _c === void 0 ? void 0 : _c.transitionInfo,
                            });
                        }));
                    }
                    else {
                        console.log('[NAVIGATION_DATA_LOAD] navData.directions has no features array. Keys on navData:', navData && typeof navData === 'object'
                            ? Object.keys(navData)
                            : typeof navData);
                    }
                }
                catch (logError) {
                    console.log('[NAVIGATION_DATA_LOAD] log failed', logError);
                }
            });
        }
    }, [mapjs, antiAliasTenants]);
    const mapStatus = useRef({
        loaded: false,
        roomAvailability: {},
        markCurrentPosition: false,
    }).current;
    const checkIfModelReqFlag = useSelector(getCheckIfModelReqFlag);
    useEffect(() => {
        checkIfModelRequired();
    }, [checkIfModelReqFlag, shouldShowWhereAmI]);
    useEffect(() => {
        if (whereAmIFloor)
            return;
        setShowWhereAmISwitchFloor(false);
        if (destinationRichMapId) {
            invokeRichMapMethod('exitNavigation');
            invokeRichMapMethod('reset');
            store.dispatch(setDirectionsPanel({ payload: null }));
            store.dispatch(setDirections({ payload: null }));
            store.dispatch(setShowQRFrame({ payload: true }));
        }
    }, [hasWhereAmISource, destinationRichMapId]);
    useEffect(() => {
        // Always keep the authoritative desired-state ref current, even while paused,
        // so the resume pass (overlay close) applies the latest availability at once.
        mapStatus.roomAvailability = roomAvailability || {};
        // Search overlay open: the map is fully occluded. Cancel any in-flight
        // highlight cycle and skip new passes — they are invisible WebGL/main-thread
        // work that only competes with the search list's scrolling (the "grey" gap).
        // When the overlay closes this effect re-runs (isSearchOpen -> false) and the
        // syncSpaceHighlights() below re-applies the current state in one diff pass,
        // so nothing is lost.
        if (isSearchOpen) {
            if (highlightCancelRef.current) {
                highlightCancelRef.current();
                highlightCancelRef.current = null;
            }
            return;
        }
        // Toggle (Rooms/Desks/All) changed: cancel the running cycle so the new
        // selection is applied immediately. Plain availability updates do NOT cancel —
        // the running cycle picks them up on its next pass, which keeps the retry tail
        // alive so late-loading desks are never dropped.
        if (prevShowOnMapRef.current !== showOnMap) {
            prevShowOnMapRef.current = showOnMap;
            if (highlightCancelRef.current) {
                highlightCancelRef.current();
                highlightCancelRef.current = null;
            }
        }
        syncSpaceHighlights();
        // `locationData` is included so a fresh LH message (e.g. a room flipping to
        // `showOnKioskAndWebApp: false`) re-runs the diff pass immediately and
        // de-highlights it, instead of waiting for the next analytics tick or a
        // floor round-trip. syncSpaceHighlights is diff-based, so an LH update that
        // changes nothing relevant settles cheaply.
    }, [roomAvailability, showOnMap, isSearchOpen, locationData]);
    // Consume the cold-load source-ready tick from the current render so the
    // pending highlight cycle observes the latest selector/floor. Additions are
    // now held until the source and resolver are ready, so no applied bookkeeping
    // needs to be discarded or repainted here.
    useEffect(() => {
        if (highlightRearmTick === 0)
            return; // skip initial mount
        if (coldRehighlightDoneRef.current)
            return; // one-shot after first ready
        // Only consume the one-shot once 'selected-floor' can actually render
        // feature-state. If a fallback timer (or an early idle) fires first, re-applying
        // now would just re-cache invisible highlights and burn the shot, so re-arm
        // shortly and retry — capped so a source that never loads can't loop forever.
        if (!isSelectedFloorSourceReady(window.rMap)) {
            if (coldRehighlightAttemptsRef.current < 30) {
                coldRehighlightAttemptsRef.current += 1;
                setTimeout(() => setHighlightRearmTick((tick) => tick + 1), 400);
            }
            return;
        }
        coldRehighlightDoneRef.current = true;
        if (highlightCancelRef.current) {
            highlightCancelRef.current();
            highlightCancelRef.current = null;
        }
        syncSpaceHighlights();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [highlightRearmTick]);
    useEffect(() => {
        checkIfFloorChangeRequired();
    }, [mapDetails.map.floorNumber]);
    useEffect(() => {
        return () => {
            if (floorReadyCleanupRef.current) {
                floorReadyCleanupRef.current();
                floorReadyCleanupRef.current = null;
            }
            if (highlightCancelRef.current) {
                highlightCancelRef.current();
                highlightCancelRef.current = null;
            }
        };
    }, []);
    function checkIfModelRequired() {
        if (!window.rMap)
            return;
        const currentState = store.getState();
        const currentSource = resolveWhereAmIFloor(getLocation(currentState), getContext(currentState));
        if (window.rMap.loaded) {
            if (mapDetails.device.modelWithScreen &&
                mapDetails.map.floorLocation === mapDetails.device.deviceLocation &&
                shouldShowWhereAmI &&
                currentSource) {
                console.log('Going to position 3D Model');
                mapStatus.markCurrentPosition = true;
                const modelPosition = [mapDetails.device.long, mapDetails.device.lat];
                const modelRotationAngle = [
                    mapDetails.device.xAngle,
                    mapDetails.device.yAngle,
                    mapDetails.device.zAngle,
                ];
                window.rMap.markCurrentPosition(modelPosition, modelRotationAngle);
            }
            // Clear camera position and currrent position if floor does not have device location
            if (!shouldShowWhereAmI ||
                !currentSource ||
                !mapDetails.device.modelWithScreen ||
                mapDetails.map.floorLocation !== mapDetails.device.deviceLocation) {
                window.rMap.removeCurrentPosition();
                deskHelperObj.removeCameraPosition();
                mapStatus.markCurrentPosition = false;
            }
        }
    }
    // If floor changes we have to call change floor on map
    function checkIfFloorChangeRequired() {
        if (!window.rMap)
            return;
        const nextFloorNumber = mapDetails.map.floorNumber;
        const previousFloorNumber = appliedFloorNumberRef.current;
        const focusOtherFloorRoom = () => {
            const otherFloorRoom = mapDetails.map.otherFloorRoom;
            if (!otherFloorRoom) {
                return;
            }
            focusRichMapLocation(otherFloorRoom.richMapId);
            if (showRoomDetailsPopup && isInteractive) {
                showRoomDetailsPopup(otherFloorRoom.richMapId, otherFloorRoom === null || otherFloorRoom === void 0 ? void 0 : otherFloorRoom.location, otherFloorRoom === null || otherFloorRoom === void 0 ? void 0 : otherFloorRoom.floorNumber);
            }
        };
        if (previousFloorNumber === null) {
            appliedFloorNumberRef.current = nextFloorNumber;
            completeFloorChangeWhenReady(nextFloorNumber, focusOtherFloorRoom);
            return;
        }
        // No floor is selected (the building-view overlay sets the floor id to ''),
        // which surfaces here as a NaN floor number. Treating that as a real floor
        // change would call changeFloor(NaN) — a no-op that leaves the previously
        // highlighted desks rendered but untracked, so on return the selector reads
        // "Rooms" while the orphaned desk highlights stay on the map. Reset the
        // selector, explicitly clear the rendered highlights, and skip the bogus
        // floor change so returning to a floor re-highlights from a clean slate.
        if (Number.isNaN(nextFloorNumber)) {
            appliedFloorNumberRef.current = nextFloorNumber;
            setActiveRichMapFloorNumber(null);
            pendingLocateFloorRef.current = null;
            if (floorReadyCleanupRef.current) {
                floorReadyCleanupRef.current();
                floorReadyCleanupRef.current = null;
            }
            store.dispatch(setShowOnMap({ payload: 'Rooms' }));
            clearAllAppliedHighlights();
            if (highlightCancelRef.current) {
                highlightCancelRef.current();
                highlightCancelRef.current = null;
            }
            return;
        }
        if (previousFloorNumber !== nextFloorNumber) {
            appliedFloorNumberRef.current = nextFloorNumber;
            // Clear any POI search highlight BEFORE changing floor: this removes the
            // old floor's highlight and, by resetting the SDK's POI selection, stops it
            // from re-applying on the new floor. Done early (not in the post-settle
            // callback) so it can't clobber the search "Go to Floor" flow, which
            // re-highlights a POI group shortly after the floor change.
            clearPoiHighlights();
            // Reset the "Show on map" selector back to its default on every floor
            // change instead of persisting the previous floor's choice.
            store.dispatch(setShowOnMap({ payload: 'Rooms' }));
            // The new floor has a different set of features, so drop what we think is
            // applied and cancel the in-flight cycle; the post-settle sync below starts
            // fresh for the new floor. Clear the rendered feature-state too (not just
            // the bookkeeping) so nothing can orphan if changeFloor doesn't clear it.
            clearAllAppliedHighlights();
            if (highlightCancelRef.current) {
                highlightCancelRef.current();
                highlightCancelRef.current = null;
            }
            console.log('Changing floor to ', nextFloorNumber);
            completeFloorChangeWhenReady(nextFloorNumber, focusOtherFloorRoom);
            invokeRichMapMethod('changeFloor', nextFloorNumber, true);
            console.log('mapDetails Updated', JSON.stringify(mapDetails), 'Selected Floor', nextFloorNumber);
            return;
        }
        if (floorReadyCleanupRef.current)
            return;
        setActiveRichMapFloorNumber(nextFloorNumber);
        checkIfModelRequired();
        focusOtherFloorRoom();
        locateWhenFloorIsReady(nextFloorNumber);
    }
    function focusRichMapLocation(richMapId) {
        if (!window.rMap)
            return;
        if (richMapId) {
            // skipMarker=false so a focus pin is dropped whenever a room is focused
            // (map click). The SDK only adds it when no route is active
            // (`!#pathFeatureCollection`), and navigate()/exitNavigation() manage the
            // destination marker, so the directions workflow is not affected.
            window.rMap.focusFeature(richMapId, false);
        }
    }
    function clearFeatureHighlight(richMapId) {
        var _a;
        if (!richMapId)
            return;
        const richMap = window.rMap;
        const featureTarget = {
            source: 'selected-floor',
            id: richMapId,
        };
        try {
            if (typeof (richMap === null || richMap === void 0 ? void 0 : richMap.removeFeatureState) === 'function') {
                richMap.removeFeatureState(featureTarget);
                return;
            }
            if (typeof ((_a = richMap === null || richMap === void 0 ? void 0 : richMap.map) === null || _a === void 0 ? void 0 : _a.removeFeatureState) === 'function') {
                richMap.map.removeFeatureState(featureTarget);
            }
        }
        catch (e) {
            console.log('to clear space highlights, map is not ready Yet!!!');
        }
    }
    // Clear every highlight we currently track from the map, then drop the
    // bookkeeping. Unlike appliedHighlightsRef.current.clear() (which only forgets
    // what we applied), this also removes the rendered feature-state, so highlights
    // can never be orphaned when changeFloor doesn't clear them for us (e.g. an
    // invalid/NaN floor while the building-view overlay is up).
    function clearAllAppliedHighlights() {
        appliedHighlightsRef.current.forEach((_availability, richMapId) => {
            clearFeatureHighlight(richMapId);
        });
        appliedHighlightsRef.current.clear();
        // The floor's feature set is about to change; drop the precomputed resolver so
        // it rebuilds for the new floor on the next pass (once its source is ready).
        highlightResolverRef.current = null;
    }
    function shouldHighlightSpace(spaceObj) {
        const level = spaceObj.level || 'room';
        if (showOnMap === 'All')
            return true;
        if (showOnMap === 'Rooms')
            return level === 'room';
        return level === 'desk';
    }
    // richMapId -> availability key for everything that should be highlighted now.
    // Scoped to the current floor: richMapIds are shaped "<floor>~<id>", and
    // getFeatures()/the source span all loaded floors, so without this filter we'd
    // try to highlight other floors' spaces (wasted work that also never settles).
    function buildDesiredHighlights() {
        const desired = new Map();
        const currentFloor = String(mapDetails.map.floorNumber);
        // Honor the hierarchical LH `deskBookable` flag (building -> floor) for the
        // floor being highlighted. When false, desks on this floor are never
        // highlighted (under any selector); rooms are unaffected. Absent/null/true
        // keep today's behavior.
        const desksBookable = resolveDeskBookable({
            location: locationData,
            floorNumber: Number(currentFloor),
        });
        // LH building/floor `showOccupancy` and room-level `hidden` flags for
        // this floor. Spaces resolving to false must not be highlighted.
        // The predicate is built once per pass and answers each space in O(1), so the highlight
        // hot path stays as fast as before. Absent/null/true keep today's behavior.
        const showOccupancy = createShowOccupancyPredicateForFloor(locationData, Number(currentFloor));
        // Room-level LH `showOnKioskAndWebApp === false` — the same gate that hides
        // the details popup must also de-highlight the space on the map. Precomputed
        // per floor so each check is O(1); absent/null/true keep today's behavior.
        const showOnKiosk = createHiddenOnKioskPredicateForFloor(locationData, Number(currentFloor));
        Object.values(mapStatus.roomAvailability).forEach((spaceObj) => {
            const richMapId = spaceObj.richMapId || '';
            if (!richMapId || !shouldHighlightSpace(spaceObj))
                return;
            if (!desksBookable && (spaceObj.level || 'room') === 'desk')
                return;
            if (!showOnKiosk(richMapId))
                return;
            if (!showOccupancy(richMapId))
                return;
            const floorPrefix = richMapId.includes('~')
                ? richMapId.slice(0, richMapId.indexOf('~'))
                : '';
            if (floorPrefix && floorPrefix !== currentFloor)
                return;
            desired.set(richMapId, (spaceObj.availability || 'Unknown').toUpperCase());
        });
        return desired;
    }
    // After changeFeatureState, confirm it actually took. getFeatures() reports ids
    // from a cross-floor cache, so a feature can look "present" while the current
    // selected-floor source (a single GeoJSON, useTiles:false) is still loading —
    // in which case changeFeatureState is silently dropped. Reading the state back
    // tells us whether it stuck; if not, we leave it unapplied so a later pass
    // retries once the source is ready.
    function isFeatureStateApplied(richMap, richMapId) {
        try {
            const map = richMap === null || richMap === void 0 ? void 0 : richMap.map;
            if (typeof (map === null || map === void 0 ? void 0 : map.getFeatureState) !== 'function')
                return true; // can't verify
            const state = map.getFeatureState({
                source: 'selected-floor',
                id: richMapId,
            });
            return !!state && Object.keys(state).length > 0;
        }
        catch (e) {
            return false;
        }
    }
    // Ray-casting point-in-polygon, identical to the SDK's isPointInPolygon:
    // `point` is [x, y]; `polygonFeature` is a Polygon whose outer ring is
    // geometry.coordinates[0]. Kept byte-for-byte equivalent so the workstation ->
    // desk-child mapping we precompute matches what the SDK computes per call.
    function pointInPolygonRing(point, polygonFeature) {
        var _a, _b;
        const ring = (_b = (_a = polygonFeature === null || polygonFeature === void 0 ? void 0 : polygonFeature.geometry) === null || _a === void 0 ? void 0 : _a.coordinates) === null || _b === void 0 ? void 0 : _b[0];
        if (!Array.isArray(ring))
            return false;
        const px = point[0];
        const py = point[1];
        let inside = false;
        for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
            const xi = ring[i][0];
            const yi = ring[i][1];
            const xj = ring[j][0];
            const yj = ring[j][1];
            const intersect = yi > py !== yj > py && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi;
            if (intersect)
                inside = !inside;
        }
        return inside;
    }
    // Build the per-floor highlight resolver ONCE:
    //   - sTypeById: feature id -> sType, for the highlightable spaces (rooms +
    //     workstations) that carry a richMapId. From the SDK's getFullFeatures()
    //     (meeting-space + work-space, de-duplicated, with geometry).
    //   - childByWorkstation: workstation id -> its 'Workstation Desk' child id.
    //     Desk children are queried by sType exactly like the SDK does (they are
    //     NOT `work-space` features, so getFullFeatures wouldn't return them), then
    //     matched to their containing workstation via point-in-polygon.
    // Returns null when the source has no features yet; the caller waits and
    // retries instead of invoking the SDK's full-source scan during cold load.
    function buildHighlightResolver(richMap) {
        const map = richMap === null || richMap === void 0 ? void 0 : richMap.map;
        if (!map || typeof (richMap === null || richMap === void 0 ? void 0 : richMap.getFullFeatures) !== 'function')
            return null;
        let fullFeatures;
        try {
            fullFeatures = richMap.getFullFeatures();
        }
        catch (e) {
            return null;
        }
        if (!Array.isArray(fullFeatures) || fullFeatures.length === 0)
            return null;
        const sTypeById = new Map();
        const workstations = [];
        fullFeatures.forEach((f) => {
            var _a, _b, _c;
            if ((f === null || f === void 0 ? void 0 : f.id) == null)
                return;
            const sType = (_a = f.properties) === null || _a === void 0 ? void 0 : _a.sType;
            sTypeById.set(String(f.id), sType);
            if (sType === 'Workstation' && ((_c = (_b = f.geometry) === null || _b === void 0 ? void 0 : _b.coordinates) === null || _c === void 0 ? void 0 : _c[0])) {
                workstations.push(f);
            }
        });
        const childByWorkstation = new Map();
        if (workstations.length > 0 &&
            typeof map.querySourceFeatures === 'function') {
            let deskPoints = [];
            try {
                deskPoints = map.querySourceFeatures('selected-floor', {
                    sourceLayer: 'maps-layer',
                    filter: ['==', 'sType', 'Workstation Desk'],
                });
            }
            catch (e) {
                deskPoints = [];
            }
            // querySourceFeatures can return the same feature once per tile; dedupe by id.
            const seen = new Set();
            const uniqueDeskPoints = deskPoints.filter((d) => {
                const key = String(d === null || d === void 0 ? void 0 : d.id);
                if ((d === null || d === void 0 ? void 0 : d.id) == null || seen.has(key))
                    return false;
                seen.add(key);
                return true;
            });
            // One-time O(workstations * desks) build (a few ms even at 400 desks), vs
            // the SDK doing this same search on every single highlight call.
            workstations.forEach((ws) => {
                var _a;
                for (let d = 0; d < uniqueDeskPoints.length; d += 1) {
                    const desk = uniqueDeskPoints[d];
                    const coords = (_a = desk === null || desk === void 0 ? void 0 : desk.geometry) === null || _a === void 0 ? void 0 : _a.coordinates;
                    if (Array.isArray(coords) && pointInPolygonRing(coords, ws)) {
                        childByWorkstation.set(String(ws.id), String(desk.id));
                        break;
                    }
                }
            });
        }
        return { sTypeById, childByWorkstation };
    }
    // Return the resolver for `floor`, building + caching it on first use. Only
    // called when the floor source is fully loaded, so getFullFeatures() returns the
    // complete feature set. Returns null if it can't be built yet, so the caller
    // can retry without doing expensive work against a partial source.
    function ensureHighlightResolver(richMap, floor) {
        const cached = highlightResolverRef.current;
        if (cached && cached.floor === floor && cached.sTypeById.size > 0) {
            return cached;
        }
        const built = buildHighlightResolver(richMap);
        if (!built || built.sTypeById.size === 0)
            return null;
        highlightResolverRef.current = Object.assign({ floor }, built);
        return highlightResolverRef.current;
    }
    // Apply one highlight with direct O(1) map.setFeatureState calls, mirroring the
    // SDK for the availability states we use (vacant/booked/occupied/unknown/hold):
    // rooms get `status` on themselves; workstations also propagate it to their
    // pre-resolved 'Workstation Desk' child (the SDK colors both). The SDK's
    // focused/selected marker branch never runs for these states, and we never pass
    // 'hotdesk', so this is behaviorally identical. Returns false when the id isn't
    // in the resolver, so the caller falls back to the SDK call.
    function applyHighlightFast(map, resolver, richMapId, statusValue) {
        if (!resolver.sTypeById.has(richMapId))
            return false;
        map.setFeatureState({ source: 'selected-floor', id: richMapId }, { status: statusValue });
        if (resolver.sTypeById.get(richMapId) === 'Workstation') {
            const childId = resolver.childByWorkstation.get(richMapId);
            if (childId != null) {
                map.setFeatureState({ source: 'selected-floor', id: childId }, { status: statusValue });
            }
        }
        return true;
    }
    // Small chunk + a real pause between chunks keeps the map responsive: applying
    // feature-state triggers a GL repaint, so doing it back-to-back every frame
    // makes the map feel sticky. Total highlight time is a bit longer by design.
    const HIGHLIGHT_CHUNK = 50; // feature ops applied per chunk
    const HIGHLIGHT_CHUNK_GAP_MS = 30; // pause between chunks so the map stays interactive
    const HIGHLIGHT_RETRY_MS = 700; // gap between retry passes (catch late-loading tiles)
    // Give up only after this many passes with NO progress while the source is
    // loaded — i.e. the only ids left genuinely don't exist in the floor source
    // (bad/stale data). Generous so high desk counts on constrained devices (Webex)
    // always finish: legitimately-present desks keep retrying until they stick.
    const HIGHLIGHT_MAX_STALE_PASSES = 25;
    const HIGHLIGHT_MAX_TOTAL_PASSES = 150; // absolute safety cap so we never loop forever
    // Apply each desk/room highlight exactly once, retrying until its feature-state
    // actually sticks. Work is chunked with pauses so the map stays interactive.
    //
    // Desired additions wait until the selected-floor source and the O(1) resolver
    // are ready. Calling the SDK while the source is still loading makes it scan a
    // partial source once per room/desk, which is quadratic at kiosk scale and the
    // resulting feature-state can be dropped anyway. Once ready, known ids use the
    // direct fast path; only genuinely unknown ids retain the SDK fallback.
    //
    // The cycle is PERSISTENT: availability updates do NOT cancel/restart it (it
    // re-reads the desired set every pass), so a live update landing mid-load can't
    // kill the retry tail and leave desks un-highlighted. It ends only when every
    // desired highlight is applied, or after several passes with no progress (the
    // remaining features genuinely aren't appearing). Toggle/floor changes cancel it
    // explicitly so they respond immediately.
    function syncSpaceHighlights() {
        // A cycle is already running; let it continue. It rebuilds the desired set each
        // pass, so it picks up newly-arrived availability data on its own.
        if (highlightCancelRef.current)
            return highlightCancelRef.current;
        let cancelled = false;
        let chunkTimer = null;
        let retryTimer = null;
        const cancel = () => {
            cancelled = true;
            if (chunkTimer !== null)
                clearTimeout(chunkTimer);
            if (retryTimer !== null)
                clearTimeout(retryTimer);
        };
        highlightCancelRef.current = cancel;
        const clearSelf = () => {
            if (highlightCancelRef.current === cancel)
                highlightCancelRef.current = null;
        };
        const applied = appliedHighlightsRef.current;
        let prevRemaining = Number.POSITIVE_INFINITY;
        let stalePasses = 0;
        let totalPasses = 0;
        const runPass = () => {
            if (cancelled)
                return;
            const richMap = window.rMap;
            if (!richMap) {
                clearSelf();
                return;
            }
            totalPasses += 1;
            const desired = buildDesiredHighlights();
            // Gate "stale" counting on the floor source being loaded. While the source
            // is still loading we keep retrying rather than giving up, so every desk in
            // the data is highlighted once its source data is available.
            const sourceReady = isSelectedFloorSourceReady(richMap);
            // Precompute the per-floor resolver once the source is fully loaded so each
            // highlight below is an O(1) map.setFeatureState instead of the SDK's O(N)
            // per-call source scan. Built at most once per floor (cached in the ref);
            // null while the source is still loading -> we fall back to the SDK call.
            const glMap = richMap === null || richMap === void 0 ? void 0 : richMap.map;
            const resolver = sourceReady
                ? ensureHighlightResolver(richMap, mapDetails.map.floorNumber)
                : null;
            const operations = [];
            let requiresSdkFallback = false;
            // Remove highlights that are no longer wanted (e.g. Desks -> Rooms toggle).
            applied.forEach((_availability, richMapId) => {
                if (!desired.has(richMapId)) {
                    operations.push(() => {
                        clearFeatureHighlight(richMapId);
                        applied.delete(richMapId);
                    });
                }
            });
            // Wait to add highlights until the floor's complete feature set has been
            // indexed. Removal operations above can still proceed during a transition.
            desired.forEach((availability, richMapId) => {
                if (applied.get(richMapId) === availability)
                    return;
                if (!sourceReady || !resolver)
                    return;
                if (!resolver.sTypeById.has(richMapId))
                    requiresSdkFallback = true;
                operations.push(() => {
                    try {
                        const statusValue = FeatureStates[availability];
                        // Fast path: direct O(1) setFeatureState via the precomputed resolver.
                        // Unknown ids retain the SDK fallback for compatibility.
                        const didFast = glMap
                            ? applyHighlightFast(glMap, resolver, richMapId, statusValue)
                            : false;
                        if (!didFast) {
                            richMap.changeFeatureState({ source: 'selected-floor', id: richMapId }, statusValue);
                        }
                        // Direct writes target an indexed source feature and therefore do
                        // not need a per-item read-back. Verify only the compatibility
                        // fallback so stale/unknown ids remain eligible for retry.
                        if (didFast || isFeatureStateApplied(richMap, richMapId)) {
                            applied.set(richMapId, availability);
                        }
                    }
                    catch (e) {
                        console.log('to highlight spaces, map is not ready Yet!!!');
                    }
                });
            });
            const afterOps = () => {
                if (cancelled)
                    return;
                let remaining = 0;
                desired.forEach((availability, richMapId) => {
                    if (applied.get(richMapId) !== availability)
                        remaining += 1;
                });
                if (remaining === 0) {
                    clearSelf(); // everything desired is highlighted
                    return;
                }
                // Track progress. Only count "stale" passes once the floor source has
                // loaded, so a slow source load (constrained devices) keeps retrying
                // instead of giving up before its features are even available.
                if (remaining < prevRemaining) {
                    stalePasses = 0;
                }
                else if (sourceReady) {
                    stalePasses += 1;
                }
                prevRemaining = remaining;
                if (stalePasses >= HIGHLIGHT_MAX_STALE_PASSES ||
                    totalPasses >= HIGHLIGHT_MAX_TOTAL_PASSES) {
                    const missing = [];
                    desired.forEach((availability, richMapId) => {
                        if (applied.get(richMapId) !== availability)
                            missing.push(richMapId);
                    });
                    console.log('[highlight] gave up with', missing.length, 'of', desired.size, 'not highlighted; sample missing richMapIds:', missing.slice(0, 8));
                    clearSelf();
                    return;
                }
                retryTimer = setTimeout(() => {
                    retryTimer = null;
                    runPass();
                }, HIGHLIGHT_RETRY_MS);
            };
            if (operations.length === 0) {
                afterOps();
                return;
            }
            // With only fast-path operations, apply one burst and let Mapbox coalesce
            // the repaint. If even one unknown id needs the SDK's O(N) fallback, retain
            // the bounded chunks so that compatibility path cannot freeze the kiosk.
            const allOperationsAreFast = Boolean(resolver) && !requiresSdkFallback;
            const chunkSize = allOperationsAreFast
                ? operations.length
                : HIGHLIGHT_CHUNK;
            const chunkGapMs = allOperationsAreFast ? 0 : HIGHLIGHT_CHUNK_GAP_MS;
            let index = 0;
            const processChunk = () => {
                if (cancelled)
                    return;
                const end = Math.min(index + chunkSize, operations.length);
                for (; index < end; index += 1) {
                    operations[index]();
                }
                if (index < operations.length) {
                    // Pause so the GL map can render this chunk and respond to input.
                    chunkTimer = setTimeout(processChunk, chunkGapMs);
                }
                else {
                    chunkTimer = null;
                    afterOps();
                }
            };
            processChunk();
        };
        runPass();
        return cancel;
    }
    const showButtons = () => {
        console.log('Buttons showing up, isInteractive:', isInteractive);
        isInteractive && setShowSearchButton(true);
        isInteractive && setShowResetButton(true);
    };
    const handleSearchButtonClick = () => {
        console.log('Search Button clicked');
        // Add your logic here
        // setShowRoomSearchPopup(true);
        store.dispatch(setRoomSearchPopUp({ payload: true }));
    };
    const handleFindMeButtonClick = () => {
        const state = store.getState();
        if (!resolveWhereAmIFloor(getLocation(state), getContext(state)))
            return;
        console.log('FindMe button clicked');
        if (mapDetails.map.floorLocation !== mapDetails.device.deviceLocation) {
            //Non where am I floor case
            setShowWhereAmISwitchFloor(true);
        }
        else {
            // Where am I floor case
            window.rMap.locate();
        }
    };
    const handleResetButtonClick = () => {
        console.log('ResetButton clicked');
        // Whether a route was active (and crossed floors) BEFORE we tear it down.
        // reset()/exitNavigation() below don't restore the SDK's floor, so a
        // cross-floor route would otherwise leave the map on the destination floor.
        const hadCrossFloorRoute = Boolean(destinationRichMapIdRef.current) && showMultifloorDirectionsBar;
        window.rMap.reset();
        window.rMap.exitNavigation();
        closeRoomDetailsPopup();
        // Only when a cross-floor route was active: clear the directions state and
        // force the map back to the desired floor. The common no-directions (or
        // same-floor) Re-Center path keeps its exact previous behavior — no extra
        // floor render or re-highlight.
        if (hadCrossFloorRoute) {
            store.dispatch(setDirectionsPanel({ payload: null }));
            store.dispatch(setDirections({ payload: null }));
            restoreDesiredFloorAfterTeardown();
        }
    };
    return (_jsxs("div", { children: [showWhereAmISwitchFloor && whereAmIFloor && (_jsx(WhereAmISwitchFloor, { currentFloorNumber: currentFloorNumber, switchFloorNumber: Number(mapDetails.device.deviceLocation), selectFloor: (id) => {
                    closeRoomDetailsPopup();
                    pendingLocateFloorRef.current = Number(mapDetails.device.deviceLocation);
                    dispatch(setSelectedLocation(id));
                    setShowWhereAmISwitchFloor(false);
                }, onClose: () => {
                    setShowWhereAmISwitchFloor(false);
                } })), isInteractive && (_jsxs(FloorMapButton, { children: [showMultifloorDirectionsBar && (_jsx(MultifloorDirectionsBar, { activeRichMapFloorNumber: activeRichMapFloorNumber, ready: isDirectionsPanelReady })), !isDirectionsPanelReady && (_jsxs(ActionBar, { children: [showSearchButton && (_jsxs(SearchButton, Object.assign({ id: "search_button", "$variant": "primary", onClick: handleSearchButtonClick }, { children: [_jsx(ButtonIcon, { "$size": "1.5rem", src: require('../../../../../assets/images/search.svg'), alt: "Search" }), t('floor.search')] }))), showFindMeButton && (_jsxs(_Fragment, { children: [_jsx(Line, {}), _jsxs(WhereAmIButton, Object.assign({ onClick: handleFindMeButtonClick }, { children: [_jsx(WhereAmIIconSpacer, { "aria-hidden": "true" }), _jsx(WhereAmIMascot, { src: require('../../../../../assets/images/spot.svg'), alt: "Where am I" }), _jsx(WhereAmIText, { children: t('floor.where-am-I') })] }))] })), showResetButton && (_jsxs(_Fragment, { children: [_jsx(Line, {}), _jsxs(ResetButton, Object.assign({ onClick: handleResetButtonClick, "$variant": "ghost" }, { children: [_jsx(ButtonIcon, { "$size": "1.5rem", src: require('../../../../../assets/images/refresh-icon.svg'), alt: "Reset" }), t('floor.recenter-map')] }))] })), !showResetButton && (_jsx("div", { children: _jsx("img", { src: "static/images/reset-floor-map-disabled.svg", alt: "Reset Disabled" }) }))] }))] }))] }));
};
export default MapComponent;
